import { ReactComponent as ChatBGIcon } from "../../../assests/chat-background-icon.svg";
import { ReactComponent as ChatFaceIcon } from "../../../assests/chat-face-icon.svg";

const IconStack = ({ size = 100 }) => {
  return (
    <div
      style={{
        position: "relative",
        width: 30,
        height: size,
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "center",
      }}
    >
      <ChatBGIcon style={{ width: "100%", height: "100%", zIndex: 1 }} />
      <ChatFaceIcon
        style={{
          position: "absolute",
          // width: size * 0.3, // 60% of background size
          // height: size * 0.3,
          zIndex: 2,
        }}
      />
    </div>
  );
};

export default IconStack;
